import Content from '../components/Content';
import Contact from '../partials/Contact';
import './Connect.scss';

const Connect = () => {

    return (
        <section className="connect-page">
            <Content 
                heading='Want to work with us?'
                variation='inverse'
            >
                <p>Right on! Fill out the form below, or send an email to us directly at <b>hello[at]makingbiscuits.co</b>.</p>
                <div className='container'>
                    <Contact />
                </div>
            </Content>
        </section>
    )
}

export default Connect;